import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode($setup["ButtonInputWithTimer"], {
      ref: "buttonInputWithTimer",
      label: "이메일 인증번호",
      name: $props.name,
      rules: $props.rules,
      placeholder: "이메일 인증번호를 입력하세요",
      value: $setup.inputValue,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (($setup.inputValue) = $event)),
      buttonTitle: "확인",
      disabled: $props.disabled,
      required: $props.required,
      successMessage: $setup.emailVerificationSuccessMsg,
      errorMessage: $setup.emailVerificationErrorMsg,
      onOnClickButton: $setup.checkEmailVerificationCode
    }, null, 8 /* PROPS */, ["name", "rules", "value", "disabled", "required", "successMessage", "errorMessage"])
  ]))
}